export default "__VITE_ASSET__CoDMCiAW__";